














import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportEmailPreview from '@/componentsV2/templates/CustomerImportEmailPreview/CustomerImportEmailPreview.vue';
import EmailPreview from '@/componentsV2/templates/EmailPreview/EmailPreview.vue';

@Component({
  components: {
    CustomerImportEmailPreview,
    EmailPreview
  }
})
export default class CustomerImportPreviewEmail extends Vue {
  @Prop({ default: '' }) coinsPerCustomer?: string;
  @Prop({ default: false }) modal?: boolean;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  mounted() {
    const { coinsPerCustomer = '' } = this.$route.query;

    this.coinsPerCustomer = String(coinsPerCustomer) || this.coinsPerCustomer;
  }
}
